import React from 'react'
import tw, { styled } from 'twin.macro'
import events from '../../content/events'
import parse from 'html-react-parser'
import { motion, AnimatePresence } from 'framer-motion'
import ChevronSvg from '../elements/ChevronSvg'
import { useBreakpoint } from '@hooks/useBreakpoint'
import igIcon from '@images/ig.svg'

const Section = tw.section`max-w-master mx-auto md:mb-24 pb-24 px-5 relative`

const Accordion = tw.div`w-full`
const AccordionItem = tw.div``
//head
const AccordionHead = tw.div`font-lobster px-2.5 sm:px-5 md:px-10 py-5 sm:py-0 sm:h-20 md:h-36 items-center grid grid-cols-12 bg-accordionGrey my-px relative ` // cursor-pointer 
const Day = tw.span`text-green text-15px sm:text-xl lg:text-2xl col-span-1 sm:col-span-2`
const Date = tw.span`text-lightBrown text-lg sm:text-2xl lg:text-4xl col-span-3 sm:col-span-4 pl-1`
const Title = tw.span`text-green text-15px leading-tight sm:text-xl lg:text-2xl col-span-6 pl-4 sm:pl-0`
const Infos = tw.span`inline-block font-roboto text-15px leading-[20px] md:text-[24px] md:leading-[29px] lg:tracking-[0.02em] mb-1 md:mb-3`
const Link = tw.a`font-roboto text-15px leading-[20px] md:text-[24px] md:leading-[29px] lg:tracking-[0.02em] pb-5 md:pb-8 mt-10`
const Icon = tw.img`inline-block h-6 pr-1`
const Arrow = styled.div`
  ${tw`absolute z-10 flex items-center justify-center w-10 h-10 transition-all duration-300 bg-white rounded-full right-2.5 sm:right-5 md:right-10 md:h-14 md:w-14`}

  svg {
    ${tw`ml-1 scale-75`}
  }
`
//content
const AccordionContent = tw(motion.div)`overflow-hidden bg-accordionGrey`
const AccordionContentWrap = tw.div`font-roboto p-2.5 sm:p-5 md:p-10 md:pb-20 grid gap-2 sm:grid-cols-12 tracking-[0.02em]`
const Heading = tw.p`font-roboto text-sm md:text-base pb-3 `
const Info = styled.div`
  ${tw`font-roboto text-lg sm:text-xl md:text-2xl md:leading-[40px] col-span-6 mb-5 sm:mb-0`}

  strong {
    ${tw`font-bold`}
  }
` // col-span-4
const Bands = tw.div`flex flex-col font-roboto text-lg sm:text-xl md:text-2xl md:leading-[40px] col-span-4 mb-5 sm:mb-0`
const MoreWrapper = tw.div`font-roboto text-lg sm:text-xl md:text-2xl md:leading-[40px] col-span-12 mb-5 sm:mb-0 mt-8`
//const Plakat = tw.div`col-span-4`

const Events = () => {
  return (
    <Section>
      <Infos>Weitere Infos kommen bald!</Infos>
      <Accordion>
        {events.map((item, index) => {
          return (
            <EventsItem
              key={`accordion-item-${index}`}
              item={item}
              index={index}
            />
          )
        })}
      </Accordion>
      <Link
        href="https://www.instagram.com/erdinger.brauhaus/?utm_medium=homepage"
        className="inline-block underline"
        target="_blank"
      >
        <Icon src={igIcon} alt="Instagram"></Icon>
        Folge uns auch auf Instagram um keine Neuigkeit zu verpassen!
      </Link>
    </Section>
  )
}

const EventsItem = ({ item, index }) => {
  const { isScreenSm, isScreenXs } = useBreakpoint()
  const [expanded, setExpanded] = React.useState(false)
  const isOpen = index === expanded
  return (
    <AccordionItem>
      <AccordionHead
        initial={false}
        onClick={() => setExpanded(isOpen ? false : index)}
      >
        <Day>
          {isScreenSm || isScreenXs ? item.head.dayMobile : item.head.day}
        </Day>
        <Date>
          {isScreenSm || isScreenXs ? item.head.dateMobile : item.head.date}
        </Date>
        <Title>{item.head.title}</Title>
        <Arrow className={`${isOpen ? '-rotate-90' : 'rotate-90'}`}>
          <ChevronSvg fill="#006E42" />
        </Arrow>
      </AccordionHead>
      <AnimatePresence initial={false}>
        {isOpen && (
          <AccordionContent
            initial="init"
            animate="open"
            exit="init"
            variants={accordionVariants}
          >
            <AccordionContentWrap>
              {item.content.info && (
                <Info>
                  <Heading>Wann und Wo</Heading>
                  {parse(item.content.info)}
                </Info>
              )}
              {item.content.bands.length > 0 && (
                <Bands>
                  <Heading>Bands</Heading>
                  {item.content.bands.map((band, bandIndex) => {
                    return (
                      <a
                        key={`band-${index}-${bandIndex}`}
                        href={band.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${
                          band.url
                            ? 'inline-block underline'
                            : 'pointer-events-none'
                        }`}
                      >
                        {band.title}
                      </a>
                    )
                  })}
                </Bands>
              )}
              {/*item.content.download && (
                <Plakat>
                  <Heading>Download Plakat</Heading>
                  <a
                    href={item.content.plakatUrl}
                    download
                    className="inline-block"
                  >
                    <img
                      className="inline-block object-contain h-[150px] sm:h-auto"
                      src={item.content.download.default}
                      alt="Herunterladen"
                    />
                  </a>
                </Plakat>
              )*/}
              {item.content.moreTitle && (
                <MoreWrapper>
                  <Heading>{item.content.moreTitle}</Heading>
                  {item.content.moreContent.map((content, contentIndex) => {
                    return (
                      <>
                        {contentIndex>0 && ', '}
                        <a
                          key={`morecontent-${index}-${contentIndex}`}
                          href={content.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`${
                            content.url
                              ? 'inline underline'
                              : 'inline pointer-events-none'
                          }`}
                        >
                          {content.title}
                        </a>
                      </>
                    )
                  })}
                </MoreWrapper>
              )}
            </AccordionContentWrap>
          </AccordionContent>
        )}
      </AnimatePresence>
    </AccordionItem>
  )
}

const transition = {
  duration: 0.5,
  ease: [0.04, 0.62, 0.23, 0.98],
}
const accordionVariants = {
  open: { height: 'auto', transition: transition },
  init: { height: 0, transition: transition },
}

export default Events
